import { Doughnut } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import colors from "../../../config/colors";

Chart.register(...registerables);

const DoughnutChart = ({ doughnutData }) => {
  const colorPalette = [colors.orange, colors.success, colors.primary];
  const categories = ["Male", "Female", "Other"];

  const data = {
    labels: doughnutData.map((value, index) => {
      const label = categories[index] || `Category ${index + 1}`;
      return `${label}(${value})`;
    }),
    datasets: [
      {
        data: doughnutData,
        backgroundColor: doughnutData.map(
          (_, index) => colorPalette[index % colorPalette.length],
        ),
        borderWidth: 1,
      },
    ],
  };
  return (
    <Doughnut
      data={data}
      options={{
        plugins: {
          legend: {
            display: true,
          },
        },
      }}
    />
  );
};

export default DoughnutChart;
